import { Component } from "@angular/core";
import {
  FormControl,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from "@angular/forms";
import { Store } from "@ngrx/store";
import { TranslatePipe } from "@ngx-translate/core";
import { AuthenticationActions } from "src/app/ngrx/actions";
import { AppState } from "src/app/ngrx/reducers";
import { AuthenticationSelectors } from "src/app/ngrx/selectors";

@Component({
  selector: "app-forgot-password",
  imports: [ReactiveFormsModule, TranslatePipe],
  templateUrl: "./forgot-password.component.html",
  styles: ``,
})
export class ForgotPasswordComponent {
  email = new FormControl<string>("", [Validators.email, Validators.required]);

  form = new FormGroup({
    email: this.email,
  });

  isResetting = this.store.selectSignal(
    AuthenticationSelectors.isResettingPassword,
  );

  constructor(private readonly store: Store<AppState>) {}

  submit() {
    if (this.form.valid) {
      this.store.dispatch(
        AuthenticationActions.forgotPassword({
          email: this.email.value || "",
        }),
      );
    }
  }
}
